import classNames from 'classnames';
import { format } from 'date-fns';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import css from './BooksCalendarHeader.module.scss';

interface Props {
  className?: string;
  dates: string[];
}

interface CalendarMonth {
  [index: string]: {
    month: string;
    year: string;
    days: string[];
  };
}

const BooksCalendarHeader = ({
  className,
  intl,
  dates,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksCalendarHeader, className);
  const calendarMonth: CalendarMonth = {};
  const calendarWeek = dates.map(date => {
    return {
      day: format(date, 'DD'),
      weekday: intl.formatDate(format(date), { weekday: 'short' }),
      weekdayUS: format(date, 'ddd'),
      month: intl.formatDate(format(date), { month: 'narrow' }),
      year: intl.formatDate(format(date), { year: 'numeric' }),
    };
  });

  dates.forEach(date => {
    if (!calendarMonth[format(date, 'YYYYMM')]) {
      calendarMonth[format(date, 'YYYYMM')] = {
        month: intl.formatDate(format(date), { month: 'narrow' }),
        year: intl.formatDate(format(date), { year: 'numeric' }),
        days: [],
      };
    }

    calendarMonth[format(date, 'YYYYMM')].days.push(format(date, 'DD'));
  });

  return (
    <div className={classes}>
      <div className={css.BooksCalendarHeader__Title}>
        {intl.formatMessage({ id: 'books.calendar.weekHeaderTitle' })}
      </div>
      <div className={css.BooksCalendarHeader__Content}>
        <div className={css.BooksCalendarHeader__Month}>
          {Object.entries(calendarMonth).map(([key, month]) => (
            <div
              className={css.BooksCalendarHeader__MonthTitle}
              data-style={'days' + month.days.length}
              key={key}
            >
              {/* TODO: 年月表示の国際化対応が必要な気がする */}
              <span data-style="year">{month.year}</span>
              <span data-style="month">{month.month}</span>
            </div>
          ))}
        </div>
        <ul className={css.BooksCalendarHeader__Week}>
          {calendarWeek.map((date, i) => (
            <li
              key={i}
              className={css.BooksCalendarHeader__Day}
              data-style={date.weekdayUS}
            >
              <span data-style="num">{date.day}</span>
              <span data-style="dow">({date.weekday})</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default injectIntl(BooksCalendarHeader);
